<div class="modal-body" [ngClass]="{ camera__mobile: isMobile() && photoSteps.includes(currentStep) && !isNativeMobileCam && !picturesUrls[currentStep] }">
  @if (verificationInProgress) {
    <div class="verificationInProgress forceDefaultColors">
      <i class="fa-solid fa-spinner-scale fa-spin"></i>
      <p>{{ 'documents.biometricAndTextExtractionInProgress' | translate }}</p>
    </div>
  }

  @if (stepInfo.title) {
    <p class="centermodal__title" [innerHTML]="stepInfo.title | translate"></p>
    @if ([Steps.LivenessError, Steps.UserBiometricError].includes(currentStep)) {
      <p class="centermodal__description">
        @if (currentStep === Steps.UserBiometricError) {
          <span [innerHTML]="stepInfo.description | translate"></span>
        }
        <img width="281" [src]="'assets/alerts/warning.svg'" class="liveness__img" />
        @if (currentStep === Steps.LivenessError) {
          <span [innerHTML]="'biometricErrors.liveness.' + (liveness.error | lowercase) | translate"></span>
        }
      </p>
    } @else if (stepInfo.description) {
      <p class="centermodal__description" [innerHTML]="stepInfo.description | translate"></p>
    }
  }

  <div class="centermodal__form" [ngClass]="{ centermodal__liveness: currentStep === Steps.Liveness }">
    @if (currentStep === Steps.Intro) {
      <ng-container [ngTemplateOutlet]="tipsContentTemplate"></ng-container>
      @if (!isMobile()) {
        <div class="centermodal__button-group centermodal__button-group--vertical mb-3">
          <button type="button" class="btn-L btn-filled justify-content-center mb-2" (click)="startDesktopCamera()" [disabled]="isLoading">
            {{ 'documents.useComputerCamera' | translate }}
          </button>
          <button type="button" class="btn-L btn-outline justify-content-center" (click)="selectDesktopMobilePrompt()" [disabled]="isLoading">
            {{ 'documents.useSmartphoneCamera' | translate }}
          </button>
        </div>
      } @else {
        <div class="centermodal__switch">
          <app-switch [(ngModel)]="isNativeMobileCam" class="mr-2"></app-switch>
          <span class="centermodal__switch-name">{{ 'documents.useSmartphoneCameraNative' | translate }}</span>
        </div>
      }
    }

    <!-- Primeiro fluxo com canvas -->
    <div class="camera" [class.d-none]="!photoSteps.includes(currentStep) || picturesUrls[currentStep] || isNativeMobileCam" [ngClass]="{ 'camera-loading': isLoading && isMobile() && firstLoad }">
      @if (!isLoading) {
        <div class="camera-focus {{ currentStep }}" [attr.data-loading]="translateService.instant('shared.loading')"></div>
      }
      <canvas id="cameraCanvas" #canvas></canvas>

      <!--      Mobile Buttons -->
      @if (isMobile()) {
        <div class="camera-background"></div>
        <button class="camera-button back" (click)="goBack()">
          <i class="fa-regular fa-chevron-left"></i>
        </button>
        <button class="camera-button" [disabled]="isLoading" (click)="takePicture()">
          <i class="fa-regular fa-camera"></i>
        </button>
        <button class="camera-button switch" type="button" (click)="toggleCamera()"><i class="fa-regular fa-rotate"></i></button>
      }
    </div>

    <!-- Segundo fluxo com input file -->
    @if (isNativeMobileCam && photoSteps.includes(currentStep)) {
      @if (!picturesUrls[currentStep]) {
        <div class="centermodal__button-group centermodal__button-group--vertical mb-5">
          <label class="btn-L btn-filled justify-content-center mb-2">
            <input
              type="file"
              class="d-none"
              accept="image/*"
              [attr.capture]="currentStep === Steps.Selfie ? 'user' : 'environment'"
              (change)="takePictureMobile($event.target['files'][0]); $any($event.target).value = ''"
            />
            {{ 'documents.' + (currentStep === Steps.Back ? 'takePhotoOfBack' : 'takePhoto') | translate }}
          </label>

          @if (currentStep === Steps.Back) {
            <button type="button" class="btn-L btn-outline justify-content-center" (click)="useFrontAsBackPicture()">
              {{ 'documents.noBackPhoto' | translate }}
            </button>
          }
        </div>
      }
    }

    <!-- Visualizaçao da imagem -->
    @if (picturesUrls[currentStep] && photoSteps.includes(currentStep)) {
      <img class="centermodal__img" [src]="picturesUrls[currentStep] | safeUrl" />
    }

    @if (currentStep === Steps.HasBackPrompt) {
      <div class="centermodal__button-group centermodal__button-group--vertical mb-3">
        <button type="button" class="btn-L btn-filled justify-content-center mb-2 w-100" (click)="currentStep = Steps.Back">
          {{ 'documents.takeBackPhoto' | translate }}
        </button>
        <button type="button" class="btn-L btn-outline justify-content-center w-100" (click)="useFrontAsBackPicture()">
          {{ 'documents.noBackPhoto' | translate }}
        </button>
      </div>
    }

    @if (currentStep === Steps.Liveness && liveness.url) {
      <iframe class="liveness forceDefaultColors" [src]="liveness.url" id="liveness-iframe" allow="camera"> </iframe>
    }

    @if (errorSteps.includes(currentStep)) {
      <div class="centermodal__button-group centermodal__button-group--vertical mb-5">
        <div class="text-center text-danger mb-3">
          <i class="fal fa-5x" [ngClass]="{ 'fa-video-slash': currentStep === Steps.CameraError, 'fa-user-slash': currentStep === Steps.VerificationError }"></i>
        </div>
        <button type="button" class="btn-L btn-filled justify-content-center mb-2" (click)="retryCamera()">
          {{ 'button.retry' | translate }}
        </button>
        @if (!isMobile()) {
          <button type="button" class="btn-L btn-outline justify-content-center mb-2" (click)="selectDesktopMobilePrompt()">
            {{ 'documents.useSmartphoneCamera' | translate }}
          </button>
        } @else {
          <button class="btn-L btn-outline justify-content-center" style="left: 20%" (click)="tryNativeMobileCam()">
            {{ 'documents.useSmartphoneCameraNative' | translate }}
          </button>
        }
      </div>
    }
  </div>

  @if (currentStep === Steps.MobilePrompt) {
    <div>
      <div class="text-center mb-4">
        @if (currentUrl) {
          <qrcode [cssClass]="'qr-code__canvas forceDefaultColors'" [qrdata]="currentUrl" [width]="200" [margin]="0"></qrcode>
        }
      </div>
      <div class="qr-code__description" [innerHTML]="'documents.accessValidationLink' | translate: { url: altPanelUrl }"></div>
      @if (referenceCode) {
        <div class="text-center">
          <div class="qr-code__code" [ngClass]="{ pfFacial: verification.type === SecurityVerificationEnum.PfFacialMatch, 'letter-spacing-2': userBiometricValidation?.operation_id }">
            {{ referenceCode.reference }}
          </div>
        </div>
      }
    </div>
  }

  @if (currentStep === Steps.BiometricAndTextExtractionError) {
    <app-verification-images-preview [images]="{ front: picturesUrls[Steps.Front], back: picturesUrls[Steps.Back], selfie: picturesUrls[Steps.Selfie] }" class="mb-3">
    </app-verification-images-preview>

    @if (verification?.payload?.code || userBiometricValidation?.payload?.code) {
      <div class="alertMessage size-S warning">
        <i class="fa-regular fa-circle-exclamation"></i>
        <div>
          <span>{{ 'biometricErrors.' + (verification?.payload?.code || userBiometricValidation?.payload?.code | lowercase) | translate }}</span>
        </div>
      </div>
    }
  }

  <div class="centermodal__button-group">
    @if (!picturesUrls[currentStep] && currentStep !== Steps.BiometricAndTextExtractionError && currentStep !== Steps.UserBiometricError) {
      <button type="button" class="btn-M btn-filled-cancel" [disabled]="isLoading" (click)="goBack()">{{ 'button.back' | translate }}</button>
    }
    @if (currentStep === Steps.UserBiometricError) {
      <button type="button" class="btn-M btn-filled-cancel" [disabled]="isLoading" (click)="modal.dismiss()">{{ 'button.close' | translate }}</button>
    }
    @if (!isMobile() && photoSteps.includes(currentStep) && !picturesUrls[currentStep]) {
      <button type="button" class="btn-M btn-filled" [disabled]="isLoading" (click)="takePicture()">
        {{ 'documents.takePhoto' | translate }}
      </button>
    }
    @if (currentStep === Steps.Liveness && liveness.ready) {
      <button type="button" class="btn-M btn-filled" [disabled]="isLoading" (click)="triggerLivenessButton()">
        {{ 'button.initLiveness' | translate }}
      </button>
    }

    <!--    Passo de visualização das imagens -->
    @if (photoSteps.includes(currentStep) && picturesUrls[currentStep]) {
      <button type="button" class="btn-M btn-filled-cancel" [disabled]="isLoading" (click)="resetPicture()">{{ 'button.retry' | translate }}</button>
      <button type="button" class="btn-M btn-filled" [disabled]="isLoading" (click)="confirmPhoto()">{{ 'documents.feedbackPositive' | translate }}</button>
    }

    @if (isMobile() && currentStep === Steps.Intro) {
      <button type="button" class="btn-M btn-filled" [disabled]="isLoading" (click)="startMobileCamera()">
        {{ 'button.forward' | translate }}
      </button>
    }

    @if (currentStep === Steps.BiometricAndTextExtractionError) {
      <button type="button" class="btn-M btn-filled-cancel" [disabled]="isLoading" (click)="modal.dismiss()">{{ 'button.cancel' | translate }}</button>
      <button type="button" class="btn-M btn-filled" (click)="resetBiometriqueOperation()" [disabled]="isLoading">
        {{ 'button.retry' | translate }}
      </button>
    }
  </div>
</div>

<ng-template #tipsContentTemplate>
  <div class="font-weight-bold">{{ 'documents.tips' | translate }}</div>
  <ul class="tips-list">
    <li>
      <i class="fal fa-lightbulb-on"></i>
      <p>{{ 'documents.findWellLitLocation' | translate }}</p>
    </li>
    <li>
      <i class="fa-regular fa-eye"></i>
      <p>{{ 'documents.holdPhoneAtEyeLevel' | translate }}</p>
    </li>
    <li>
      <i class="fal fa-flashlight"></i>
      <p>{{ 'documents.avoidStrongBacklights' | translate }}</p>
    </li>
  </ul>
</ng-template>
